export let RevenueReportAggregateEnum = /*#__PURE__*/function (RevenueReportAggregateEnum) {
  RevenueReportAggregateEnum["Day"] = "day";
  RevenueReportAggregateEnum["Week"] = "week";
  RevenueReportAggregateEnum["Month"] = "month";
  RevenueReportAggregateEnum["Quarter"] = "quarter";
  RevenueReportAggregateEnum["Year"] = "year";
  RevenueReportAggregateEnum["AllTime"] = "all-time";
  return RevenueReportAggregateEnum;
}({});